setTimeout(() => {
  const updateAndHide = (variant) => {
    const sizeEl = document.getElementById('variant-size');
    if (!sizeEl) return;

    // Si tenemos datos de variante, actualizamos el texto
    if (variant && Array.isArray(variant.options) && variant.options.length > 0) {
      sizeEl.textContent = variant.options[0];
    }

    const card = sizeEl.closest('.info-card');
    if (!card) return;

    const value = (sizeEl.textContent || '').trim();
    const hideValues = ['', '-', 'Default Title'];

    // Mostrar u ocultar según valor
    card.style.display = hideValues.includes(value) ? 'none' : '';
  };

  // 1️⃣ Ejecutar en carga inicial
  updateAndHide();

  // 2️⃣ Escuchar evento custom de cambio de variante
  document.addEventListener('variant:change', (event) => {
    updateAndHide(event.detail && event.detail.variant);
  });

  // 3️⃣ Fallback: escuchar cambios en selects de opciones
  document.querySelectorAll('[name^="options"]').forEach((el) => {
    el.addEventListener('change', () => updateAndHide());
  });
}, 100);
